var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutritionlogstart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 780,
    viewBox: "0 0 360 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 884,
    transform: "translate(-22.6909 -15.2188)",
    fill: "url(#paint0_radial_5722_9791)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5722_9791)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.809,
    cy: 724.781,
    rx: 99.5,
    ry: 144,
    fill: "#12E3FF",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5722_9791",
    x: -31.6909,
    y: 380.781,
    width: 599,
    height: 688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_5722_9791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5722_9791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-366.5 -493) rotate(61.8345) scale(1865.38 1865.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F9CFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554194,
    stopColor: "#0D0616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionlogstart);
export default __webpack_public_path__ + "static/media/nutritionlogstart.7bf398a85e08d505cb10f4a3088d46ec.svg";
export { ForwardRef as ReactComponent };